import { useMemo } from 'react';

import { useAuthContext } from './useAuthContext';

type User = {
  roles: { permissions: Permission[] }[];
};
type Permission = {
  name: string;
};

export const useDataPermission = () => {
  const { user } = useAuthContext() as { user: User };

  const permissionData = useMemo(() => {
    if (user) {
      const permissions: string[] = [];
      if (user?.roles) {
        user.roles.forEach((role) => {
          permissions.push(...role.permissions.map((p) => p.name));
        });
      }
      const uniquePermissions = [...new Set(permissions)];

      return new Set(uniquePermissions);
    }
    return new Set();
  }, [user]);

  return permissionData;
};
